/* Utilities */
import './utilities/common';
import './utilities/skip-link-focus';
import './utilities/smooth-scroll';

/* Modules */
import './modules/accordions';
import './modules/contact';
import './modules/expansion';
import './modules/flipboxes';
import './modules/hexagons';
import './modules/navigation';
import './modules/resources';
import './modules/tableau';
import './modules/themes';

/* Styles */
import '../scss/application.scss';

/* Ready */
window.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded');
});
